import { api } from './client';

/** Seguimientos de Richard (tanda 3, ola B). Prefijo: /api/seguimientos (módulo `seguimientos`). */

export type AccionSeguimiento = 'hecho' | 'posponer' | 'lo_hago_yo' | 'aprobar' | 'editar' | 'saltar';
export type EtapaManual = 'zoom_hecho' | 'tour' | 'siguiente_paso';

export interface ItemDeSeguimiento {
  id: string;
  codigo: string;
  tema: string | null;
  tipo: string;
  estado: string;
  que: string;
  conQuien: string;
  telefono: string | null;
  conversationId: string | null;
  /** ISO. */
  cuando: string;
  borrador: string | null;
  fallo: string | null;
}

export interface Seguimientos {
  vencidos: ItemDeSeguimiento[];
  hoy: ItemDeSeguimiento[];
  estaSemana: ItemDeSeguimiento[];
  masAdelante: ItemDeSeguimiento[];
  paraAprobar: ItemDeSeguimiento[];
}

export const listar = (tema?: string) => api.get<Seguimientos>('/api/seguimientos', { query: { tema } });

export const accion = (id: string, que: AccionSeguimiento, extra: { texto?: string; dias?: number } = {}) =>
  api.post<{ ok: true }>(`/api/seguimientos/${id}/accion`, { accion: que, ...extra });

export const etapa = (conversationId: string, cual: EtapaManual) =>
  api.post<{ id: string; codigo: string }>(`/api/seguimientos/conversacion/${conversationId}/etapa`, { etapa: cual });

/** Solo en la demo (SIMULADOR_PERMITIDO): Richard le escribe al número de avisos. */
export const escribirComoRichard = (texto: string) =>
  api.post<{ conversationId: string; respuesta: string | null }>('/api/simulador/richard', { texto });

/** Solo en la demo: reclasificar y planificar ya, sin esperar al guardián. */
export const planificarDemo = () => api.post<{ reclasificadas: number; planificados: number }>('/api/simulador/seguimientos/planificar', {});
